import { useMemo } from "react";

export function useSubdomain() {
  return useMemo(() => {
    if (typeof window === "undefined") return null;

    const hostname = window.location.hostname;
    const parts = hostname.split(".");

    // localhost with subdomain (admin.localhost, matuskii.localhost)
    if (parts.length === 2 && parts[1] === "localhost") {
      return parts[0];
    }

    // standard domains (foo.example.com)
    if (parts.length >= 3) {
      return parts[0];
    }

    // no subdomain (localhost, example.com)
    return null;
  }, []);
}